import React from "react";

function ProductDetailsActionsBar(props) {
    return (
      <div className={props.isVisible ? "actionsbar show" : "actionsbar"}>
          {props.extraHtml}
          <div className="row buttons-row">
              <a className={props.btnClassName} onClick={props.buttonAction}>
                  {props.buttonName}
              </a>
          </div>
      </div>
    );
}

export default ProductDetailsActionsBar;
